import React, { useState, useEffect, useContext, useReducer } from 'react';
import { Table, Page } from '../../components';
import { default as SpecNew } from './spec';
import { default as SpecPart } from './specPart';
import { insertSpec, updateSpec, deleteSpec,checkCanDeleteSpec, getGoodsSpecListByGoodsId } from '../../services/Goods';

import {
  Button,
  Modal,
  message
} from 'antd';
import {
  ExclamationCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  CloseOutlined
} from '@ant-design/icons';

import { MasterContext } from '../../App';
import './style';

export default React.forwardRef((props, ref) => {
  const { /*surface, unit,*/ currentUser, authorities } = useContext(MasterContext);
  const { goods, onCloseCallback } = props;
  const [isLoadding, setLoadding] = useState(false);
  const [isShowSpecNew, setShowSpecNew] = useState(false);
  const [isShowSpecEdit, setShowSpecEdit] = useState(false);
  const [isShowGoodsPart, setShowGoodsPart] = useState(false);
  const [selectedSpecIndex, setSelectedSpecIndex] = useState(undefined);
  const onGoodsSelect = (goods) => {
    if (goods.length === 0) {
      setShowGoodsPart(false);
      return;
    }
    try {
      const key = 'update_goods_part';
      console.log('onSave:', goods);
      message.loading({ content: `正在新建配套产品 [...]...`, key });
      /* insertGoods(supplier.id, goods).then(() =>
        getGoodsList(supplier.id).then(goods => {
          setGoodsList(goods);
          setShowGoodsSelect(false);
          setSelectedGoodsIndex(goods.length - 1);
          message.success({ content: `新建客户产品成功 [#${supplier.name_cn}]`, key, duration: 2 });
        })); */
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initialState = {
    rows: []
  };
  function reducer(state, action) {
    switch (action.type) {
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'selected':
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      default:
        throw new Error();
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  const { rows } = state;
  const selectedSpec = rows[selectedSpecIndex] || {};

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getGoodsSpecListByGoodsId(goods.id).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1]).then(values => {
      setLoadding(false);
    });
  }, []);

  const reload = () => {
    var p1 = new Promise((resolve, reject) => {
      getGoodsSpecListByGoodsId(goods.id).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  const showDeleteConfirm = (index, item) => {
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{item.name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteSpec(item);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onClickPart = (index) => {
    setSelectedSpecIndex(index);
    setShowGoodsPart(true)
  }
  const onEditSpec = async (index) => {
    setSelectedSpecIndex(index);
    setShowSpecEdit(true);
  }

  const onDeleteSpec = async (item) => {
    try {
      const key = 'delete_goods_spec';
      console.log('onDeleteSpec:', item);

      checkCanDeleteSpec(goods.id, item.id).then(data=> {
        if (data.length > 0) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>该产品已被下列订单使用，不能删除。</strong><br/>
                {
                  data.map(x=> {
                    return <div><strong>{x.po_code}</strong> - {x.no}</div>
                  })
                }
            </span>,
          });
          return;
        }
        message.loading({ content: '正在删除产品号...', key });
        deleteSpec(goods.id, item.id).then(() => {
          reload().then(() => {
            message.success({ content: `删除产品号成功 [#${item.name}]`, key, duration: 2 });
          })
        })
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onNewSpec = (values) => {
    try {
      const key = 'create_goods_spec';
      console.log('onNewCallback:', values);
      message.loading({ content: '正在新建产品号...', key });
      insertSpec(goods.id, values).then(() => {
        reload().then(() => {
          setShowSpecNew(false);
          message.success({ content: `新建产品号成功 [#${values.name}]`, key, duration: 2 });
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveSpec = (values) => {
    try {
      const key = 'create_goods_spec';
      console.log('onNewCallback:', values);
      message.loading({ content: '正在修改产品号...', key });
      updateSpec(goods.id, selectedSpec.id, values).then(() => {
        reload().then(() => {
          setShowSpecEdit(false);
          message.success({ content: `修改产品号成功 [#${values.name}]`, key, duration: 2 });
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }


  return (
    <div style={{ padding: '1.5rem' }}  >
      <Table
        isLoadding={isLoadding}
        expandable={false}
        title={`产品号管理`}
        newLabel="新建产品号"
        showFilter={false}
        showView={false}
        showNewLabel={authorities.find(x => x === 'create_goods') || authorities.find(x => x === 'edit_goods') || currentUser.category_id === 1}
        rows={rows}
        total_rows={rows.length}
        onNew={() => setShowSpecNew(!isShowSpecNew)}
        header={[
          {
            label: '产品号', item: 'name', width:'220px'
          },
          { label: '尺寸', item: 'size', align: 'center',  width:'160px' },
          { label: '重量(g)', item: 'weight', align: 'right', width:'160px' },
          {
            label: '配套产品', item: 'part_count', align: 'center', width:'160px', render: (text, row, index) => {
              return <Button style={{ padding: 0 }} type="link" onClick={() => onClickPart(index)} size="small">{text > 0 ? text : '添加配套产品'}</Button>
            }
          },
          // {
          //   label: '表面处理', item: 'surface_id', align: 'center', render: (text, row, index) => {
          //     return <div>{surface.find(x => x.id === text).name}</div>
          //   }
          // },
          // {
          //   label: '计量单位', item: 'unit_id', align: 'center', render: (text, row, index) => {
          //     return <div>{unit.find(x => x.id === text).name_en}</div>
          //   }
          // },
          {
            label: '操作', item: '', align: 'center',width:'220px', render: (text, row, index) => {
              return [
                <Button icon={<EditOutlined />} onClick={() => onEditSpec(index)} type="link" size="small" />,
                <Button icon={<DeleteOutlined />} onClick={() => showDeleteConfirm(index, row)} danger type="text" size="small" />
              ]
            }
          }
        ]}
        bordered={true} />
      <div style={{ textAlign: 'right', padding:'1rem 0' }}>
        <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
      </div>
      <Page
        title="新建产品号"
        width="40vw"
        onCloseCallback={() => setShowSpecNew(!isShowSpecNew)}
        body={<SpecNew onCloseCallback={() => setShowSpecNew(!isShowSpecNew)} onSaveCallback={onNewSpec} />}
        visible={isShowSpecNew}
      />
      <Page
        title="修改产品号"
        width="40vw"
        onCloseCallback={() => setShowSpecEdit(!isShowSpecEdit)}
        body={<SpecNew onCloseCallback={() => setShowSpecEdit(!isShowSpecEdit)} spec={selectedSpec} onSaveCallback={onSaveSpec} />}
        visible={isShowSpecEdit}
      />
      <Page
        title="配套产品管理"
        width="960px"
        onCloseCallback={() => setShowGoodsPart(false)}
        body={<SpecPart spec={selectedSpec} onCloseCallback={()=>setShowGoodsPart(false)} />}
        visible={isShowGoodsPart}
      />
    </div>
  )
});
